<template>
  <div class="pandemy-info" id="kup-cegielke">
    <div class="content-wrapper">
      
      <div class="single-box single-box-left">
        <img src="@/assets/images/mapa.png" alt="Mapa" />
      </div>

      <div class="single-box single-box-right">
          <div class="right__top">
              <img src="@/assets/images/logo_wosp.png" alt="Logo WOSP" />
              <div>
                <h2>Zbiórka Allegro dla WOŚP</h2>
                <p>
                  Razem z Wami zbieraliśmy pieniądze na Fundusz Interwencyjny Wielkiej Orkiestry Świątecznej Pomocy. Za zebrane środki, Fundacja kupiła najbardziej potrzebny sprzęt dla służby zdrowia.
                  <br /><br />
                  Dziękujemy za Wasze wsparcie!
                </p>
              </div>
          </div>
          <!-- <div class="right__middle">
            Razem WYgramy!
          </div> -->
          <div class="right__bottom">
            <!-- <div class="bottom__top">
              <a target="_blank" href="https://allegro.pl/oferta/9143412726"><span>5</span>zł</a>
              <a target="_blank" href="https://allegro.pl/oferta/9146203676"><span>10</span>zł</a>
              <a target="_blank" href="https://allegro.pl/oferta/9146206927"><span>20</span>zł</a>
              <a target="_blank" href="https://allegro.pl/oferta/9146210209"><span>30</span>zł</a>
              <a target="_blank" href="https://allegro.pl/oferta/9146211840"><span>50</span>zł</a>
              <a target="_blank" href="https://allegro.pl/oferta/9146213072"><span>100</span>zł</a>
            </div>
            <div class="bottom__bottom">
              <a target="_blank" rel="noopener noreferrer" href="https://allegro.pl/uzytkownik/sztab-allegro">Kup teraz</a>
            </div> -->
            <small-counter></small-counter>
          </div>
      </div>

    </div>
  </div>
</template>

<script>
  import smallCounter from '@/components/counter_small';

  export default {
    components: {
      smallCounter
    }
  };
</script>

<style lang="scss" scoped>

  @import "@/scss/_general.scss";

  .pandemy-info {
    padding-bottom: 20px;

    .content-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      @media only screen and (max-width: 991px) {
        flex-direction: column;
      }

      .single-box {
        padding: 30px 45px;
        background: #fff;
        display: flex;
        flex-direction: row;

        &.single-box-left {
            background: #fff;
            width: calc(40% - 12px);
            display: flex;
            justify-content: center;
            // align-content: center;

            @media only screen and (max-width: 1200px) {
              flex-direction: column;
            }

            @media only screen and (max-width: 991px) {
              width: 100%;
              margin-bottom: 24px;
              flex-direction: row;
            }

            @media only screen and (max-width: 576px) {
                flex-direction: column;
            }

            & > img {
                max-width: 100%;
                max-height: 500px;
                margin-top: auto;
                margin-bottom: auto;
            }

            // .left__left {
            //     width: 40%;
            //     display: flex;
            //     flex-direction: column;
            //     justify-content: center;
            //     color: #fff;

            //     @media only screen and (max-width: 1200px) {
            //       width: 100%;
            //     }

            //     @media only screen and (max-width: 991px) {
            //       width: 40%;
            //     }

            //     @media only screen and (max-width: 576px) {
            //       width: 100%;
            //     }

            //     h2 {
            //         font-size: 28px;
            //         line-height: 34px;

            //         @media only screen and (max-width: 1200px) {
            //           margin-bottom: 20px;
            //         }

            //         @media only screen and (max-width: 576px) {
            //           font-size: 28px;
            //           line-height: 38px;
            //         }
            //     }

            //     .copy-top {
            //         margin-top: auto;
            //         margin-bottom: auto;
            //         display: flex;
            //         flex-direction: column;

            //         @media only screen and (max-width: 1200px) {
            //           margin-bottom: 20px;
            //         }

            //         .copy-top__1 {
            //             font-size: 44px;
            //             line-height: 37px;
            //             font-weight: 600;

            //             @media only screen and (max-width: 576px) {
            //               font-size: 30px;
            //             }
            //         }

            //         .copy-top__2 {
            //             font-size: 24px;
            //             line-height: 30px;
            //             font-weight: 600;

            //             @media only screen and (max-width: 576px) {
            //               font-size: 18px;
            //             }
            //         }

            //         .copy-top__3 {
            //             font-size: 24px;
            //             line-height: 30px;
            //             font-weight: 300;

            //             @media only screen and (max-width: 576px) {
            //               font-size: 18px;
            //             }
            //         }
            //     }

            //     .copy-bottom {
            //         display: flex;
            //         flex-direction: column;

            //         .copy-bottom__1 {
            //             font-size: 36px;
            //             line-height: 34px;
            //             font-weight: 600;

            //             @media only screen and (max-width: 576px) {
            //               font-size: 30px;
            //             }
            //         }

            //         .copy-bottom__2 {
            //             font-size: 24px;
            //             line-height: 30px;
            //             font-weight: 300;

            //             @media only screen and (max-width: 576px) {
            //               font-size: 18px;
            //             }
            //         }
            //     }
            // }

            // .left__right {
            //     width: 40%;
            //     display: flex;
            //     justify-content: flex-end;
            //     flex-direction: column;
            //     align-items: flex-end;
            //     text-align: right;

            //     @media only screen and (max-width: 1200px) {
            //       width: 100%;
            //       justify-content: center;
            //       align-items: center;
            //       margin-top: 30px;
            //     }

            //     @media only screen and (max-width: 991px) {
            //       width: 40%;
            //       justify-content: flex-end;
            //       align-items: flex-end;
            //     }

            //     @media only screen and (max-width: 576px) {
            //         align-items: flex-start;
            //         margin-top: 0px;
            //     }

            //     // @media only screen and (max-width: 576px) {
            //     //   display: none;
            //     // }

            //     img {
            //         display: block;
            //         width: 100%;
            //         max-width: 250px;
            //         margin-top: auto;
            //         margin-bottom: auto;

            //         @media only screen and (max-width: 1200px) {
            //           max-width: 180px;
            //           margin-left: -30px;
            //         }

            //         @media only screen and (max-width: 576px) {
            //             display: none;
            //         }
            //     }

            //     a {
            //         color: #fff;
            //         font-size: 24px;
            //         line-height: 28px;
            //         text-decoration: none;
            //         font-weight: 300;

            //         &:hover {
            //             color: darken(#fff, 10%);
            //         }

            //         @media only screen and (max-width: 1200px) {
            //             margin-top: 20px;
            //         }

            //         @media only screen and (max-width: 576px) {
            //             font-size: 18px;
            //         }
            //     }
            // }
        }

        &.single-box-right {
            background: #fff;
            width: calc(60% - 12px);
            display: flex;
            flex-direction: column;

            @media only screen and (max-width: 991px) {
              width: 100%;
            }

            .right__top {
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-top: auto;
              text-align: center;

              @media only screen and (max-width: 1200px) {
                align-items: center;
              }

              @media only screen and (max-width: 576px) {
                flex-direction: column;
              }

              img {
                max-width: 120px;
                width: 100%;
                height: 116px;
                display: block;
                margin-bottom: 30px;

                @media only screen and (max-width: 1200px) {
                  max-width: 100px;
                  height: 96px;
                }

                @media only screen and (max-width: 576px) {
                  margin: 0 auto 20px;
                }
              }

              h2 {
                font-size: 28px;
                line-height: 34px;
                color: #FF5A00;
                margin-bottom: 15px;
              }

              p {
                color: #3E4E57;
                font-size: 18px;
                line-height: 28px;

                @media only screen and (max-width: 768px) {
                  font-size: 14px;
                  line-height: 22px;
                }
              }
            }

            .right__middle {
              color: #3E4E57;
              font-weight: 600;
              font-size: 18px;
              line-height: 28px;
              text-align: center;
              padding: 10px 0 25px;
            }

            .right__bottom {
              padding-top: 25px;
              display: flex;
              flex-direction: column;
              margin-bottom: auto;

              .bottom__top {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: space-between;
                width: 90%;
                align-self: center;

                a {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 32.5%;
                  height: 55px;
                  background: #fff;
                  text-align: center;
                  border: 2px #DADFE4 solid;
                  margin-bottom: 8px;
                  text-decoration: none;
                  color: #FF5A00;
                  font-size: 22px;
                  line-height: 30px;
                  transition: all .1s ease-in-out;

                  @media only screen and (max-width: 1200px) {
                    width: 49.5%;
                  }

                  @media only screen and (max-width: 576px) {
                    width: 100%;
                  }

                  span {
                    font-size: 29px;
                    line-height: 30px;
                    margin-right: 4px;
                    margin-top: -3px;
                  }

                  &:hover {
                    background: #FF5A00;
                    color: #fff;
                    border: 2px #FF5A00 solid;
                    transform: scale(1.03);
                  }
                }
              }

              .bottom__bottom {
                display: flex;
                justify-content: center;
                margin-top: 15px;

                a {
                  background: #FF5A00;
                  color: #fff;
                  font-size: 17px;
                  line-height: 23px;
                  padding: 15px 25px;
                  border-radius: 2px;
                  text-decoration: none;
                  text-transform: uppercase;
                  letter-spacing: 1.92px;
                  font-weight: 400;

                  &:hover {
                    background: darken(#FF5A00, 5%);
                  }
                }
              }
            }
        }
      }
    }
  }

</style>